import React, { ReactNode } from 'react';
import { Element } from './TabPanel.styles';

export interface TabPanelProps {
  className?: string;
  children?: ReactNode;
}

const TabPanel = ({ children, ...props }: TabPanelProps) => {
  return <Element {...props}>{children}</Element>;
};

export default TabPanel;
